export default class BlogModel {
    constructor(id,titulo, contenido, contenidoCorto) {
        this.id = id || 0;
        this.titulo = titulo || "";
        this.contenido = contenido || "";
        this.contenidoCorto || "";
        this.fecha = new Date();
    }
}


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_site/src/services/blog/blog.model.js